import { AdminNoPaddingRoutes } from "@src/routes/loggedIn/adminPageRoutes/adminNoPaddingRoutes";
import { AdminRoutes } from "@src/routes/loggedIn/adminPageRoutes/adminRoutes";

export const AdminPageRoutes = [...AdminRoutes];
